import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut, ShieldCheck, PlusCircle, BookOpen, User, PlayCircle } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user && user.role === "admin";

  const linkBase = "px-3 py-1.5 font-display text-sm uppercase tracking-tight brutal-sm bg-white";
  const linkActive = "bg-lime";

  return (
    <header className="border-b-[3px] border-black bg-paper sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-2 group">
          <span className="inline-flex h-10 w-10 items-center justify-center brutal-sm bg-hot text-white rotate-1n">
            <Sparkles className="h-5 w-5" strokeWidth={3} />
          </span>
          <span className="font-display text-xl sm:text-2xl tracking-tighter">
            slang<span className="text-hot">.</span>dex
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          <NavLink data-testid="nav-browse-link" to="/" end className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}>
            <BookOpen className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Browse
          </NavLink>
          <NavLink data-testid="nav-walkthrough-link" to="/walkthrough" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}>
            <PlayCircle className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Tour
          </NavLink>
          {user && (
            <NavLink data-testid="nav-submit-link" to="/submit" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}>
              <PlusCircle className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Submit
            </NavLink>
          )}
          {user && (
            <NavLink data-testid="nav-my-submissions-link" to="/my-submissions" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""}`}>
              <User className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Mine
            </NavLink>
          )}
          {isAdmin && (
            <NavLink data-testid="nav-admin-link" to="/admin" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : ""} bg-lilac`}>
              <ShieldCheck className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Admin
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {!user ? (
            <>
              <Link data-testid="nav-login-link" to="/login" className="px-3 py-1.5 font-display text-sm uppercase brutal-sm bg-white brutal-hover">Log in</Link>
              <Link data-testid="nav-register-link" to="/register" className="px-3 py-1.5 font-display text-sm uppercase brutal-sm bg-hot text-white brutal-hover">Join</Link>
            </>
          ) : (
            <>
              <span data-testid="nav-user-email" className="hidden sm:inline font-mono-tag text-xs uppercase">{user.email}</span>
              <button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="px-3 py-1.5 font-display text-sm uppercase brutal-sm bg-white brutal-hover"
              >
                <LogOut className="inline h-4 w-4 mr-1 -mt-0.5" strokeWidth={3} /> Out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
